import { useEffect, useRef } from "react";
import { useLivestreamChat } from "../../context/LivestreamChatProvider";

interface LivestreamChatSlotProps {
  expanded?: boolean;
}

export const LivestreamChatSlot = ({ expanded }: LivestreamChatSlotProps) => {
  const { registerChatSlot } = useLivestreamChat();
  const slotRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    registerChatSlot(slotRef.current);
    return () => {
      registerChatSlot(null);
    };
  }, [registerChatSlot]);

  return (
    <div
      ref={slotRef}
      className={
        expanded
          ? "flex flex-[0_0_clamp(18rem,24vw,24rem)] min-w-[16rem] min-h-0 max-[900px]:flex-[0_0_auto] max-[900px]:w-full max-[900px]:min-w-0 max-[900px]:h-full max-[900px]:min-h-0"
          : "flex flex-[0_0_clamp(16rem,22vw,22rem)] min-w-[16rem] min-h-0 max-[900px]:flex-[0_0_auto] max-[900px]:w-full max-[900px]:min-w-0 max-[900px]:h-[min(11rem,26vh)]"
      }
    />
  );
};
